import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

// 动态加载设备组件
const Home = () => import('@/views/Home.vue');
const Friend = () => import('@/views/Friend.vue');
const Data = () => import('@/views/Data.vue');
const Admin = () => import('@/views/Admin.vue');

export default new Router({
  routes: [{
    path: '/',
    component: () => import('@/layouts/MobileLayout'),
    redirect: '/home',
    children: [{
      path: '/home',
      component: Home
    }, {
      path: '/friend',
      component: Friend
    }, {
      path: '/data',
      component: Data
    }, {
      path: '/admin',
      component: Admin
    }]
  }]
});
